import { registerFormInputComponent } from "@bb-vendure/admin-ui/core";
import { CountryListComponent } from "./components/country-shipping-method-list/country-shipping-method-list.component";

export default [
  registerFormInputComponent(
    'country-form-input',
    CountryListComponent
  ),
];
